// extracted by mini-css-extract-plugin
module.exports = {"component":"Notifications_component__3dY8a"};